import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import Layout from '@/layouts/ModernTwoColumnsLayout.vue'
import { computed, onMounted, onServerPrefetch, watch } from 'vue'
import { useCategoriesStore } from '@/store/categories-store'
import Typography from '@/components_new/Typography.vue'
import TheEnd from '@/components_new/TheEnd/TheEnd.vue'
import Link from '@/components_new/Link.vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { CategoryType } from '@/types'
import { useHead } from '@unhead/vue'
import { useAppStore } from '@/store/app-store'
import { ROUTE_NAMES, ROUTE_NAMES_VALUES } from '@/router/constants'
import { useTr } from '@/composables/use-tr'
import { useI18nAddon } from '@/i18n/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'GamesCategories',
  setup(__props) {

const tr = useTr()
const categoriesStore = useCategoriesStore()
const appStore = useAppStore()
const route = useRoute()
const { categoriesInfo } = storeToRefs(categoriesStore)
const { currentLocale } = useI18nAddon()

const MAP_TO_API_CATEGORY: Partial<Record<ROUTE_NAMES_VALUES, CategoryType>> = {
    [ROUTE_NAMES.ALL_TAGS]: 'tag',
    [ROUTE_NAMES.ALL_CATEGORIES]: 'category',
    [ROUTE_NAMES.ALL_SERIES]: 'series',
}

const currentCategoryType = computed(() => MAP_TO_API_CATEGORY[route.name as ROUTE_NAMES_VALUES] as CategoryType)

const currentCategoryInfo = computed(() => categoriesInfo.value?.[currentCategoryType.value])

const pageTranslation = computed(() => {
    switch (currentCategoryType.value) {
        case 'tag':
            return {
                page_title: tr('gamesCategories.tags_page_title'),
                page_description: tr('gamesCategories.tags_page_description'),
            }
        case 'series':
            return {
                page_title: tr('gamesCategories.series_page_title'),
                page_description: tr('gamesCategories.series_page_description'),
            }
        default:
            return {
                page_title: tr('gamesCategories.category_page_title'),
                page_description: tr('gamesCategories.category_page_description'),
            }
    }
})

onServerPrefetch(async () => {
    if (route.name === ROUTE_NAMES.ALL_CATEGORIES_OLD_PAGE) {
        appStore.setPageStatus(301)
        appStore.setTargetURL(`/all/categories`)
        return
    }
    await Promise.all([categoriesStore.setMainData(), categoriesStore.setCategoriesInfo(currentCategoryType.value)])
})

onMounted(async () => {
    await Promise.all([categoriesStore.setMainData(), categoriesStore.setCategoriesInfo(currentCategoryType.value)])
})

watch(
    () => currentCategoryType.value,
    async (type) => {
        await categoriesStore.setCategoriesInfo(type)
    },
)

watch(currentLocale, async () => {
    await Promise.all([categoriesStore.setMainData(), categoriesStore.setCategoriesInfo(currentCategoryType.value)])
})

const metaTitle = computed(() => {
    switch (currentCategoryType.value) {
        case 'tag':
            return tr('gamesCategories.tags_meta_title')
        case 'series':
            return tr('gamesCategories.series_meta_title')
        default:
            return tr('gamesCategories.category_meta_title')
    }
})

const metaDescription = computed(() => {
    switch (currentCategoryType.value) {
        case 'tag':
            return tr('gamesCategories.tags_meta_description')
        case 'series':
            return tr('gamesCategories.series_meta_description')
        default:
            return tr('gamesCategories.category_meta_description')
    }
})
const pageMeta = computed(() => {
    return {
        title: () => metaTitle.value,
        meta: [
            {
                name: 'title',
                content: metaTitle.value,
            },
            {
                name: 'description',
                content: metaDescription.value,
            },
            {
                property: 'og:title',
                content: metaTitle.value,
            },
            {
                property: 'og:description',
                content: metaDescription.value,
            },
            {
                name: 'twitter:title',
                content: metaTitle.value,
            },
            {
                name: 'twitter:description',
                content: metaDescription.value,
            },
        ],
    }
})

useHead(pageMeta)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, null, {
    default: _withCtx(() => [
      _createElementVNode("main", {
        class: _normalizeClass(_ctx.$style.page)
      }, [
        _createElementVNode("section", {
          class: _normalizeClass(_ctx.$style.page_title)
        }, [
          _createVNode(Typography, {
            is: "h1",
            size: "s",
            responsive: false
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(pageTranslation.value.page_title), 1)
            ]),
            _: 1
          }),
          _createVNode(Typography, {
            is: "p",
            size: "s",
            responsive: false,
            class: _normalizeClass(_ctx.$style.description)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(pageTranslation.value.page_description), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ], 2),
        _createVNode(Typography, {
          is: "ul",
          type: "label",
          size: "m",
          class: _normalizeClass(_ctx.$style.categories)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCategoryInfo.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(_ctx.$style.category_item)
              }, [
                _createVNode(Link, {
                  to: item.href,
                  color: "purple-600",
                  "data-interface-target": currentCategoryType.value,
                  class: _normalizeClass(_ctx.$style.category_link)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "data-interface-target", "class"])
              ], 2))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(TheEnd)
      ], 2)
    ]),
    _: 1
  }))
}
}

})